

export default {
    name: "service",

    props: {
        tableData: {
            required: true,//必须要传的
        },
        tableColumn: {
            required: true
        },
        iconType: {},

        hyperlink: {},

        currentPage:{
            default: 1
        },
        total: {
            default: 0
        },
        pageSize: {
            default: 20
        },
        pageSizes: {
            type: Array,
            default: () => {
                return [20, 25, 50, 100, 200, 500, 1000]
            }
        },
        pagination: {
            default: true
        },
        rowKey:{
            default:'id'
        },
        selection: {
            default: false
        }
    },
    data() {
        return {
            multipleSelection: [],//表格内的选择框

            allIcon: [//操作栏的icon，操作按钮
                {
                    id: 'user',
                    class: 'xqli-user-icon',
                    title: '分配账号',
                }, {
                    id: 'add',
                    class: 'xqli-add-icon',
                    title: '添加',
                }, {
                    id: 'link',
                    class: 'xqli-link-icon',
                    title: '绑定菜单',
                }, {
                    id: 'bar',
                    class: 'xqli-bar-icon',
                    title: '详情',
                }, {
                    id: 'edit',
                    class: 'xqli-edit-icon',
                    title: '编辑',
                }, {
                    id: 'delete',
                    class: 'xqli-delete-icon',
                    title: '删除',
                },
            ],
        }
    },

    computed: {
        iconArr() {
            let arr = []
            if (this.iconType && this.iconType.length > 0) {
                arr = this.allIcon.filter(el => this.iconType.indexOf(el.id) > -1)
            }
            return arr
        }
    },

    watch: {

    },

    created() {
        // console.log(this.tableData,'tableData')
    },

    mounted() {

    },

    methods: {
        columnWidth(prop) {
            let minWidth = ''
            switch (prop) {
                case 'id':
                    // minWidth = '50'
                    break;
                case 'sn':
                    minWidth = '100'
                    break;
                case 'declareType':
                    minWidth = '10'
                    break;
            }
            return minWidth
        },

        handleSelectionChange(val) {
            // console.log(val, 'page-table')
            // this.multipleSelection = val;
            this.$emit('selection', val)
        },

        handleClickIcon(index, row, icontype) {
            switch (icontype) {
                case 'user':
                    this.$emit('user', index, row)
                    break;
                case 'add':
                    this.$emit('add', index, row)
                    break;
                case 'link':
                    this.$emit('link', index, row)
                    break;
                case 'bar':
                    this.$emit('bar', index, row)
                    break;
                case 'edit':
                    this.$emit('edit', index, row)
                    break;
                case 'delete':
                    this.$emit('delete', index, row)
                    break;
            }
        },




        handleSizeChange(val) {
            this.$emit('changeSize', val)
        },
        handleCurrentChange(val) {
            this.$emit('changeCurrentPage', val)
        },


        handleSortChange({column, prop, order}) {
            this.$emit('sort', prop, order)
        },
    },
}
